module.exports = __webpack_public_path__ + "img/pic-logo-ys.026ff1af.png";